import { PreSplashPage } from 'Components/Shared/PreSplashPage/PreSplashPage'
import { usePageDuration } from 'hooks/usePageDuration'
import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'

interface PreSplashScreenProps {
  nextPath: string
}

export const PreSplashScreen: FC<PreSplashScreenProps> = ({ nextPath }) => {
  const history = useHistory()

  const stopDuration = usePageDuration('preSplash')
  const handlePreSplashScreenNextPage = (): void => {
    stopDuration()
    history.push(nextPath)
  }

  return (
    <PreSplashPage
      buttonText="Continue"
      onClick={handlePreSplashScreenNextPage}
    />
  )
}
